import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  message: string;
};

export default class AppErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
    message: '',
  };

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      message: error?.message || 'Unknown UI error',
    };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('UI crash caught by AppErrorBoundary:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <div
            className="max-w-sm w-full rounded-2xl p-4"
            style={{ background: 'rgba(10,25,47,0.92)', border: '1px solid rgba(99,179,237,0.35)' }}
          >
            <p className="text-sm font-bold mb-2" style={{ color: 'var(--text-1)' }}>
              Интерфейс перезапускается
            </p>
            <p className="text-xs mb-3" style={{ color: 'var(--text-3)' }}>
              Произошла ошибка рендера. Нажмите кнопку ниже.
            </p>
            <p className="text-[11px] mb-3" style={{ color: '#FC814A' }}>
              {this.state.message}
            </p>
            <button
              type="button"
              onClick={() => {
                this.setState({ hasError: false, message: '' });
                window.location.href = '/catalog';
              }}
              className="w-full py-2 rounded-xl text-sm font-bold"
              style={{ background: 'linear-gradient(135deg,#1a6eb5,#0e4a8c)', color: '#fff', border: '1px solid rgba(99,179,237,0.45)' }}
            >
              Открыть каталог
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

